<template>
  <v-navigation-drawer
    v-model="drawer"
    app
    dark
    clipped
    floating
    class="elevation-2"
    overflow
    v-bind="$attrs"
    data-cy="menu">
    <slot name="menu-before-list"></slot>
    <v-list
      id="menulist"
      expand
      data-cy="menu-list"
      :dense="$vuetify.breakpoint[$theme.options.compact.drawer]">
      <core-menulist v-if="items && items.length > 0" :items="items" />
    </v-list>
    <slot name="menu-after-list"></slot>
  </v-navigation-drawer>
</template>

<script>
  import CoreMenu from '@bmp-vue/core/components/core/menu.vue';

  // Sobrescreve o CoreMenu do @bmp-vue/core (registrado globalmente em main.js)
  // apenas para adicionar `expand` ao v-list. Sem essa prop o Vuetify fecha os
  // demais grupos do menu lateral ao abrir um novo (comportamento accordion).
  // O template é uma cópia do original; a lógica (items, drawer, filterAvaliables)
  // é herdada via `extends`, então continua acompanhando o pacote.
  export default {
    name: 'CoreMenu',
    extends: CoreMenu 
  };
</script>
